<template>
    <div class="mb-4">
        <p>
            {{$t('SELECT_ONE')}}
        </p>

        <base-input-select
            :select-options="setOptions"
            @input="selectOption"
        />

        <info-modal
            v-if="learnMoreSets"
            :button="learnMoreSetsCaption"
            :text="learnMoreSets"
        />
    </div>
</template>

<script>
    import BaseInputSelect from './BaseInputSelect.vue';
    import InfoModal from './InfoModal.vue';

    import allStores from '../stores/all';
    import { useCustomizerStore } from '../stores/customizer';

    export default {
        mixins: [allStores],

        components: {
            BaseInputSelect,
            InfoModal,
        },

        props: {
            itemData: Object,
        },

        data() {
            const customizerStore = useCustomizerStore();

            const selected = customizerStore.viewController.blueprint.custom[`v-selected-set-${this.itemData.code}`] ?? 'Custom';

            return {
                selected,
            };
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            setOptions() {
                const options = JSON.parse(this.itemData.custom['v-sets']);

                return options.map((o) => ({
                    label: o.name,
                    code: o.name,
                    selected: o.name === this.selected,
                    placements: o.placements,
                }));
            },

            learnMoreSets() {
                return this.itemData.custom['v-learn-more-sets'];
            },

            learnMoreSetsCaption() {
                return this.itemData.custom['v-learn-more-sets-caption'];
            },
        },

        mounted() {
            this.viewController.on('stateChanged.placementsets', this.matchPlacements);
        },

        beforeUnmount() {
            this.viewController.off('stateChanged.placementsets');
        },

        methods: {
            matchPlacements() {
                if (this.working) {
                    return;
                }

                const active = new Set();

                // eslint-disable-next-line no-restricted-syntax
                for (const placement of this.itemData.placements) {
                    const option = this.viewController.selectedAtPlacement(placement.code);
                    if (!option.placeholder) {
                        active.add(placement.code);
                    }
                }

                // eslint-disable-next-line no-restricted-syntax
                for (const set of this.setOptions) {
                    if (set.placements == null) {
                        // eslint-disable-next-line no-continue
                        continue;
                    }
                    if (active.size !== set.placements.length) {
                        // eslint-disable-next-line no-continue
                        continue;
                    }

                    let all = true;

                    // eslint-disable-next-line no-restricted-syntax
                    for (const placement of set.placements) {
                        if (!active.has(placement)) {
                            all = false;
                        }
                    }

                    if (all) {
                        // Found something...
                        if (this.selected !== set.label) {
                            this.selected = set.label;
                        }

                        this.viewController.blueprint.custom[`v-selected-set-${this.itemData.code}`] = set.label;
                        return;
                    }
                }

                // Select the default...
                if (this.selected !== 'Custom') {
                    this.selected = 'Custom';
                    this.viewController.blueprint.custom[`v-selected-set-${this.itemData.code}`] = 'Custom';
                }
            },

            selectOption(set) {
                // Prevent reentry.
                this.working = true;

                // First, unselect all placements.
                // eslint-disable-next-line no-restricted-syntax
                for (const placement of this.itemData.placements) {
                    const placeholder = placement.components.find((x) => x.placeholder);

                    if (placeholder) {
                        this.viewController.updateComponent(placement.code, placeholder.code);
                    }
                }

                if (set.placements) {
                    // Then select non-placeholders.
                    // eslint-disable-next-line no-restricted-syntax
                    for (const placement of set.placements) {
                        const actual = this.itemData.placements.find((p) => p.code === placement);

                        if (actual) {
                            const notPlaceholder = actual.components.find((x) => !x.placeholder);

                            if (notPlaceholder) {
                                this.viewController.updateComponent(actual.code, notPlaceholder.code);
                            }
                        }
                    }
                }

                this.working = false;

                this.selected = set.label;
                this.viewController.blueprint.custom[`v-selected-set-${this.itemData.code}`] = set.label;
            },
        },
    };
</script>
